__turbopack_context__.v({
  "ButtonThumb": "_7PqFOa_ButtonThumb",
  "Buttons": "_7PqFOa_Buttons",
  "Footer": "_7PqFOa_Footer",
  "FooterWrapper": "_7PqFOa_FooterWrapper",
  "LastUpdated": "_7PqFOa_LastUpdated",
  "Line": "_7PqFOa_Line",
  "Wrapper": "_7PqFOa_Wrapper",
});
